<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="hrissecondary" 
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>mdi-transfer-up</v-icon>
          </v-btn>
        </template>
      
        <span>Escalation Record</span>
      </v-tooltip>
    </template>
   
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      title="Claim Request Escalation"
      text="Add/Update claim request escalation record"
      class="mb-0"
    >
      <template v-if="dialog && !loading">
        <v-container
          data-simplebar
          class="pt-4"
        >
          <v-row dense>
            <v-col cols="3">
              Requester:
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="8">
              <span class="font-weight-bold"> {{ claimRequest.employee.person.name }} </span>
            </v-col>
            
            <v-col cols="3">
              Reference No.
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="8">
              <span class="font-weight-bold"> {{ claimRequest.reference_number }} </span>
            </v-col>
          </v-row>
        </v-container>
        <form>
          <v-container class="py-0">
            <v-row no-gutters>
              <v-col
                cols="12"
              >
                <v-autocomplete
                  v-model="escalateTo"
                  v-validate="'required'"
                  :error-messages="errors.collect('escalateTo')"
                  :loading="loading"
                  :items="approvers"
                  data-vv-name="escalateTo"        
                  data-vv-as="higher approver"        
                  label="Escalate To"
                  item-text="person.name"
                  item-value="employee_uid"
                >
                  <v-tooltip
                    slot="append"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="warning"
                        v-on="on"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>List uplines of the superior of this requester from the lowest to the highest.</span>
                    <span v-if="approvers.length <= 0"> If none listed, no more higher approver found.</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="remark"
                  v-validate="'required|max:2000'"
                  :rows="2"
                  :error-messages="errors.collect('remark')"
                  data-vv-name="remark"        
                  label="Remark"
                />
              </v-col>
            </v-row>
          </v-container>
        </form>
      </template>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing || deleteProgressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          v-if="claimRequest.claim_request_escalation"
          :loading="deleteProgressing"
          :disabled="loading || progressing"
          color="red"
          class="white--text"
          @click="deleteConfirmationDialog = true"
        >
          delete
        </v-btn>
        <v-btn
          :loading="progressing"
          :disabled="loading || !remark || !escalateTo || deleteProgressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          save
        </v-btn>
      </v-card-actions>
    </material-card>
    
    <v-dialog
      v-model="deleteConfirmationDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="headline">
          Delete Confirmation
        </v-card-title>
        <v-card-text>
          Are you sure to delete this escalation record?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="deleteProgressing"
            text
            @click="deleteConfirmationDialog = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="deleteProgressing"
            color="hrissecondary"
            class="white--text"
            @click="deleteEscalation"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimRequest: {
        type: Object,
        required: true,
      },
    },  
    data () {
      return {
        dialog: null,
        deleteConfirmationDialog: null,
        loading: false,
        progressing: false,
        deleteProgressing: false,
        remark: null,
        approvers: [],
        escalateTo: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.loading = true
      
        this.$api.hrisEmployees().list('?escalation=' + this.claimRequest.employee_uid)
          .then((res) => {
            this.approvers = res.data
            this.loading = false
          })

        if (this.claimRequest.claim_request_escalation) {
          this.escalateTo = this.claimRequest.claim_request_escalation.employee_uid
          this.remark = this.claimRequest.claim_request_escalation.remark
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.claimRequestEscalations().create(this.claimRequest.id, this.prepareFormData())
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })

                this.escalateTo = null
                this.remark = null
                this.dialog = false
              })
              .catch((e) => {
                if (e.response.data.message) {
                  this.$snack({ 
                    color: 'error',
                    message: e.response.data.message,
                  })
                } else {
                  this.$snack({ 
                    color: 'error',
                    message: 'Update failed',
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          employee_uid: this.escalateTo,
          remark: this.remark,
        }
      },
      deleteEscalation () {
        this.deleteProgressing = true 

        this.$api.claimRequestEscalations().delete(this.claimRequest.claim_request_escalation.id)
          .then(response => {
            this.$emit('updated')
            this.$snack({ message: response.data.status })

            this.escalateTo = null
            this.remark = null
            this.deleteConfirmationDialog = false
            this.dialog = false
          })
          .catch((e) => {
            if (e.response.data.message) {
              this.$snack({ 
                color: 'error',
                message: e.response.data.message,
              })
            } else {
              this.$snack({ 
                color: 'error',
                message: 'Delete failed',
              })
            }
          })
          .then(() => {
            this.deleteProgressing = false
          })
      },
    },
  }
</script>

<style scoped>
.font-10{
  font-size:10px !important;
}
.v-data-table ::v-deep td{
  font-size: 13.5px !important;
}
</style>
